import React, { useCallback, useEffect } from 'react';
import { isEmpty } from 'lodash';
import { BareDropdown, PaginatedDropdown } from 'taboola-ultimate-ui';
import { useFormFieldValue } from 'modules/taboola-common-frontend-modules/formData';
import { useCampaignLevelConversions } from '../../ConversionOptimization/hook/useCampaignLevelConversions';
import { CampaignRuleItemRender } from './CampaignRuleItemRender';
import styles from './conversionRulesDropDown.module.scss';

export const ConversionRulesDropDown = ({ setHasOptions, disabled, disabledConversionRules, message, fieldName }) => {
    const { value: conversionRules, onChange: onChangeConversionRules } = useFormFieldValue({
        field: fieldName,
    });

    const { options, loadConversionRules, setCurrentOptions } = useCampaignLevelConversions(
        disabledConversionRules,
        fieldName
    );

    const addItem = useCallback(
        item => {
            const { id, displayName, status, avgCvr, conversions } = item;
            onChangeConversionRules(prev => [...prev, { id, displayName, status, avgCvr, conversions }]);
        },
        [onChangeConversionRules]
    );

    useEffect(() => {
        setHasOptions(prev => prev || !isEmpty(options));
    }, [options, setHasOptions]);

    return (
        <div className={styles['dropdown-container']}>
            <PaginatedDropdown
                id="rule-selector"
                onChange={addItem}
                searchable
                disabled={disabled}
                value={conversionRules?.[0]?.id?.toString() ?? null}
                enabledWhileSearching
                options={options}
                loadPage={loadConversionRules}
                onOptionsLoaded={setCurrentOptions}
                placeholder={message}
                DropdownMenuComponent={BareDropdown}
                optionItemRenderer={CampaignRuleItemRender}
                selectedValueObject={null}
            />
        </div>
    );
};
